import React, { useState, useEffect, useContext } from "react"

import queryString from "query-string"

import { GlobalAuthContext } from "../context/authContext"

import {
  CART_FETCH,
  SHORTLIST_FETCH,
} from "../components/company-profile/statistics/action/statisticsAction"
import {
  SEARCH_DATA,
  GET_RECOMMENDATIONS,
  FETCH_SEARCH_HISTORY,
  DELETE_SEARCH_HISTORY,
  SAVE_SEARCH_RESULTS,
} from "../components/shared-actions/searchActions"

import Search from "../components/search/search"
import { GET_CONFIG_DATA } from "../components/shared-actions/get-config-data"
import { navigate } from "gatsby-link"
import Spinner from "../components/spinner/spinner"
import ModalComponent from "../components/modal/modal"
import ConfirmModal from "../components/search/confirm-dialog"
import InputDialogModal from "../components/search/input-dialog"

const CandidateSearchPage = ({ location }) => {
  const search = queryString.parse(location.search)
  const [listOfSearch, setListOfSearch] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchLoading, setSearchLoading] = useState(true)
  const [listOfRecommendations, setListOfRecommendations] = useState([])
  const [cart, setCart] = useState({})
  const [shortlist, setShortlist] = useState({})
  const [savedSearch, setSavedSearch] = useState([])
  const [filterData, setFilterData] = useState({})
  const [config, setConfig] = useState({})
  const [processing, setProcessing] = useState(false)
  const [bulkProcessing, setBulkProcessing] = useState(false)
  const [cP, setCP] = useState(0)
  const [meta, setMeta] = useState({})
  const [showModal, setShowModal] = useState(0)
  const [searchText, setSearchText] = useState("")
  const [deleteId, setDeleteId] = useState()
  const [keywords, setKeywords] = useState()
  const [message, setMessage] = useState()

  const handleModalHide = (value, id) => {
    if (value === false) {
      setShowModal(0)
    } else {
      setShowModal(value)
      setDeleteId(id)
    }
  }

  const handleSearchSave = value => {
    const data = {
      company_id: state.user.company.id,
      keywords: keywords,
      name: searchText,
    }
    setSearchText("")
    SAVE_SEARCH_RESULTS(
      data,
      setMessage,
      savedSearch,
      setSavedSearch,
      setShowModal
    )
  }

  const handleSaveModalHide = (value, keywords) => {
    setKeywords(keywords)
    setShowModal(value)
  }

  const deleteConfirm = (value, id) => {
    DELETE_SEARCH_HISTORY(id, setShowModal, value, setSavedSearch, savedSearch)
  }

  const handleSearchSaveTextChange = value => {
    setSearchText(value)
  }

  const { state, dispatch } = useContext(GlobalAuthContext)

  const checkUrlValidity = setLoading => {
    if (
      !!search.country &&
      !!search.minSalary &&
      !!search.minExperience &&
      !!search.maxExperience &&
      !!search.position
    ) {
      if (state.config) {
        if (
          Number(search.maxExperience) <= Number(search.minExperience) ||
          Number(search.maxExperience) > state.config.experience.length - 1
        ) {
          return navigate("/")
        }
        if (Number(search.minSalary) > Number(search.maxSalary)) {
          return navigate("/")
        }
        const country =
          state?.profile?.country ?? state?.config?.current_country_id
        if (search.country?.toString() !== country?.toString()) {
          navigate(
            "/search-candidates?" +
              new URLSearchParams({ ...search, country: country })
          )
        } else {
          setLoading(false)
          SEARCH_DATA(
            location.search,
            setListOfSearch,
            setMeta,
            cP,
            setSearchLoading
          )
        }
      }
      if (state.isAuthenticated && state.user.company?.id) {
        FETCH_SEARCH_HISTORY(setSavedSearch)
      }
      if (
        location.search &&
        location.search.includes("position") &&
        location.search.includes("industry")
      ) {
        GET_RECOMMENDATIONS(location.search, setListOfRecommendations)
      }
    } else {
      return navigate("/")
    }
  }

  useEffect(() => {
    if (!state.config) {
      GET_CONFIG_DATA(setConfig, dispatch)
    } else {
      setConfig(state.config)
    }
    if (state?.user?.company?.id) {
      CART_FETCH(dispatch, setCart)
      SHORTLIST_FETCH(dispatch, setShortlist, state.user.company.id)
    }

    if (state.isEmailVerified && state.isAuthenticated) {
      checkUrlValidity(setLoading)
    } else if (!localStorage.token && !state.isAuthenticated) {
      checkUrlValidity(setLoading)
    } else if (!state.isEmailVerified && state.isAuthenticated) {
      navigate("/verify-email")
    }
  }, [state.config, bulkProcessing, location.search, cP]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      {!loading ? (
        <>
          <Search
            listOfSearch={listOfSearch}
            listOfRecommendations={listOfRecommendations}
            cart={cart}
            config={config}
            state={state}
            bulkProcessing={bulkProcessing}
            setBulkProcessing={setBulkProcessing}
            search={search}
            setMessage={setMessage}
            savedSearch={savedSearch}
            setSavedSearch={setSavedSearch}
            shortlist={shortlist}
            filterData={filterData}
            processing={processing}
            setProcessing={setProcessing}
            setFilterData={setFilterData}
            setCP={setCP}
            cP={cP}
            message={message}
            handleModalHide={handleModalHide}
            handleSaveModalHide={handleSaveModalHide}
            setShowModal={setShowModal}
            searchLoading={searchLoading}
            location={location}
            meta={meta}
          />
          <ModalComponent show={showModal !== 0} setShow={handleModalHide}>
            {showModal === 1 && (
              <ConfirmModal
                id={deleteId}
                setShow={handleModalHide}
                onOkClick={deleteConfirm}
                text={
                  "Are you sure to delete this search history? You cannot undo after deleting."
                }
              />
            )}
            {showModal === 2 && (
              <InputDialogModal
                onChange={handleSearchSaveTextChange}
                searchText={searchText}
                setShow={setShowModal}
                onSave={handleSearchSave}
              />
            )}
          </ModalComponent>
        </>
      ) : (
        <Spinner />
      )}
    </>
  )
}

export default CandidateSearchPage
